/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { jsonWebKeySetsList } from "../funcs/jsonWebKeySetsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListJSONWebKeySetsResult } from "../models/components/listjsonwebkeysetsresult.js";
import {
  ListJsonWebKeySetsRequest,
  ListJsonWebKeySetsSecurity,
} from "../models/operations/listjsonwebkeysets.js";
import { unwrapAsync } from "../types/fp.js";
export type ListJsonWebKeySetsQueryData = ListJSONWebKeySetsResult;

export function prefetchListJsonWebKeySets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListJsonWebKeySetsRequest | undefined,
  security?: ListJsonWebKeySetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListJsonWebKeySetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListJsonWebKeySetsQuery(
  client$: GramCore,
  request?: ListJsonWebKeySetsRequest | undefined,
  security?: ListJsonWebKeySetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListJsonWebKeySetsQueryData>;
} {
  return {
    queryKey: queryKeyListJsonWebKeySets({ gramSession: request?.gramSession }),
    queryFn: async function listJsonWebKeySetsQueryFn(
      ctx,
    ): Promise<ListJsonWebKeySetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(jsonWebKeySetsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListJsonWebKeySets(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "jsonWebKeySets", "list", parameters];
}
